<template>
  <div class="live-commentary-statistic">
    <section
      v-for="(name,idx) in statisticNameArr"
      :key="idx"
    >
      <div class="live-commentary-statistic-top">
        <p class="score">
          {{ homeStatistics[idx] }}
        </p>
        <p>{{ name }}</p>
        <p class="score">
          {{ awayStatistics[idx] }}
        </p>
      </div>
      <VProgress :percent="percent[idx]" />
    </section>

    <BottomBarClose />
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import VProgress from 'fe-vui/progress'
import SlideLeftFixed from '../config/slideLeftFixed.mixin.js'
import BottomBarClose from './BottomBarClose.vue'

export default {
  name: 'MsgStatistic',
  components: {
    VProgress,
    BottomBarClose
  },
  mixins: [SlideLeftFixed],
  inheritAttrs: false, // 不回退defaultMarkets为 attr
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup() {
    const matchDetailStore = useMatchDetailStore()
    const { currentFixedType, currentFixedId } = storeToRefs(matchDetailStore)

    return {
      currentFixedType,
      currentFixedId
    }
  },
  data() {
    return {
      isOnce: false,
      actFinished: false,
      fixedLeftTime: 6,
      needSlice: false
    }
  },
  computed: {
    statisticNameArr() {
      // 需要做处理，底部展示5条
      const { homeStatistics } = this.data.commentaryText[0]
      const all = Object.keys(homeStatistics)

      const length = this.needSlice && all.length > 5 ? 5 : all.length
      return all.slice(0, length)
    },
    homeStatistics() {
      const { statisticNameArr } = this
      const { homeStatistics } = this.data.commentaryText[0]
      const arr = []
      statisticNameArr.forEach((item) => {
        arr.push(homeStatistics[item])
      })

      return arr
    },
    awayStatistics() {
      const { statisticNameArr } = this
      const { awayStatistics } = this.data.commentaryText[0]
      const arr = []
      statisticNameArr.forEach((item) => {
        arr.push(awayStatistics[item])
      })
      return arr
    },
    percent() {
      const { homeStatistics, awayStatistics } = this
      const arr = []
      homeStatistics.forEach((item, i) => {
        const left = parseInt(item)
        const all = left + parseInt(awayStatistics[i])
        const originPer = (left / all) * 100

        let per
        if (originPer === 0) per = 2
        else per = originPer === 100 ? 98 : originPer

        arr.push(per)
      })
      return arr
    },
    showFixed() {
      // 有时间 优先级低于voucher 是推送 位于底部
      return !!(this.fixedLeftTime && this.currentFixedType < 4 && this.data.isPushMsg && this.isBottom)
    }
  },
  methods: {
    compPriority() {
      return this.currentFixedType < 4
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.live-commentary-statistic {
  box-sizing: border-box;
  padding: 0 10/@rem 15/@rem;
  border-radius: 4/@rem;
  background-color: @major;
  transform: translateX(0);

  &-top {
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    padding: 15/@rem 10/@rem 0;
    color: @white;
    font-size: 10/@rem;

    .score {
      font-size: 12/@rem;
    }
  }

  .v-progress-cont {
    height: 6/@rem;
    border-radius: 6/@rem;
    background-color: @green;
  }

  .v-progress-left {
    background-color: #ff751a;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  .v-progress-ball {
    display: none;
  }

  &.fixed-bottom {
    position: fixed;
    z-index: 10;
    right: 0;
    bottom: 70/@rem;
    left: 0;
    width: 296/360 *100%;
    border-radius: 4px;
    margin: auto;
    box-shadow: 0 -15/@rem 30/@rem 10/@rem @dark;
    transform: translateX(-100%);

    .bottom-bar-close {
      display: flex;
    }
  }
}

</style>
